import { create } from 'zustand';
import { FFmpeg } from '@ffmpeg/ffmpeg';

interface FFMPEG {
  ffmpegInstance: any;
  isLoaded: boolean;
  loadFFmpeg: () => void;
}
const useFFmpegStore = create<FFMPEG>((set) => ({
  ffmpegInstance: null,
  isLoaded: false,
  loadFFmpeg: async () => {
    const ffmpeg = new FFmpeg();
    await ffmpeg.load();
    set({ ffmpegInstance: ffmpeg, isLoaded: true });
  },
}));

export default useFFmpegStore;
